import React, { useRef, useCallback, memo } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/components/map_interaction/ExtendPlaceInfoBox.css';
import { FaCalendarAlt, FaClock } from 'react-icons/fa';

const ExtendPlaceInfoBox = ({ showExtension, notes, onNotesChange, date, onDateChange, time, onTimeChange, readOnly = false }) => {
  const dateInputRef = useRef(null);
  const timeInputRef = useRef(null);

  const handleDateButtonClick = useCallback(() => {
    if (!readOnly && dateInputRef.current) {
      dateInputRef.current.setFocus();
    }
  }, [readOnly]);

  const handleTimeButtonClick = useCallback(() => {
    if (!readOnly && timeInputRef.current) {
      timeInputRef.current.setFocus();
    }
  }, [readOnly]);

  const shouldRender = showExtension && !(readOnly && (!notes.trim() && !date && !time));
  if (!shouldRender) return null;

  return (
    <div className="extend-place-info-box">
      <div className="info-box-content">
        <div className="date-time-picker">
          {(!readOnly || (readOnly && date)) && (
            <div className="picker-container">
              <div className="picker-button-container" onClick={!readOnly ? handleDateButtonClick : undefined}>
                <FaCalendarAlt alt="Date Icon" className="picker-icon" />
                <DatePicker
                  selected={date}
                  onChange={onDateChange}
                  dateFormat="do MMMM yyyy"
                  placeholderText="Select a date"
                  className="custom-date-picker"
                  ref={dateInputRef}
                  disabled={readOnly}
                  aria-label="Select date"
                />
              </div>
            </div>
          )}
          {(!readOnly || (readOnly && time)) && (
            <div className="picker-container">
              <div className="picker-button-container" onClick={!readOnly ? handleTimeButtonClick : undefined}>
                <FaClock alt="Time Icon" className="picker-icon" />
                <DatePicker
                  selected={time}
                  onChange={onTimeChange}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="h:mm aa"
                  placeholderText="Select a time"
                  className="custom-time-picker"
                  ref={timeInputRef}
                  disabled={readOnly}
                  aria-label="Select time"
                />
              </div>
            </div>
          )}
        </div>
        {(!readOnly || (readOnly && notes.trim() !== "")) && (
          <textarea
            value={notes}
            onChange={!readOnly ? (e) => onNotesChange(e.target.value) : undefined}
            placeholder="Add your notes here"
            className="info-box-textarea"
            readOnly={readOnly}
            aria-label="Place notes"
          />
        )}
      </div>
    </div>
  );
};

export default memo(ExtendPlaceInfoBox);
